import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FeedOperatorHint } from 'src/app/core/services/feed.service';
import { SearchInputComponent } from '../../search-input/search-input.component';
import { SuiButtonComponent } from '@sui/button';
import { TranslatePipe } from '@ngx-translate/core';
import { HighlightPipe } from '../../../pipes/highlight.pipe';

@Component({
  selector: 'app-feed-operator-list',
  templateUrl: './feed-operator-list.component.html',
  styleUrls: ['./feed-operator-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SearchInputComponent,
    SuiButtonComponent,
    TranslatePipe,
    HighlightPipe,
  ],
})
export class FeedOperatorListComponent {
  @Input() feedOperators: FeedOperatorHint[];

  searchQuery: string;
  filteredFeedOperators: FeedOperatorHint[];

  @Output() onAddOperator = new EventEmitter<string>();

  ngOnInit() {
    this.filteredFeedOperators = this.feedOperators;
  }

  addOperator(feedOperatorHint: FeedOperatorHint) {
    this.onAddOperator.emit(feedOperatorHint.name + ':');
  }

  onSearchChange(newValue: string) {
    if (newValue) {
      this.searchQuery = newValue;
      this.filteredFeedOperators = this.feedOperators.filter((hint) =>
        hint.name.toLowerCase().includes(newValue.toLowerCase()),
      );
    } else {
      this.searchQuery = '';
      this.filteredFeedOperators = this.feedOperators;
    }
  }
}
